module.exports = __webpack_public_path__ + "media/images/emblems/Neerach-blazon-777afdf75bdec8be98f7e83d15f8b6e8.svg";